import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import { useStatusTrackContext } from '../StatusTrackerContext/index.es.js';
import { StatusTrackerDescription } from '../StatusTrackerDescription/StatusTrackerDescription.es.js';
import { StatusTrackerLabel } from '../StatusTrackerLabel/StatusTrackerLabel.es.js';
import { StatusTrackerStep } from '../StatusTrackerStep/StatusTrackerStep.es.js';

const StatusTrackerLoading = ()=>{
    const { numLoadingSteps = 2 } = useStatusTrackContext();
    return jsx(Fragment, {
        children: Array(numLoadingSteps).fill(null).map((_, i)=>jsxs(StatusTrackerStep, {
                "data-testid": "loading-step",
                isLastStep: i === numLoadingSteps - 1,
                children: [
                    jsx(StatusTrackerLabel, {}),
                    jsx(StatusTrackerDescription, {})
                ]
            }, i))
    });
};
StatusTrackerLoading.displayName = 'StatusTracker.Loading';

export { StatusTrackerLoading };
//# sourceMappingURL=StatusTrackerLoading.es.js.map
